export default __webpack_public_path__ + "static/media/modal2.e9bf0ca9.jpg";